import React, { useState, useEffect } from "react";
import { Form, useActionData, useNavigation } from "react-router-dom";

function Login() {
  const actionData = useActionData();
  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting" || navigation.state === "loading";
  const [hideError, setHideError] = useState(false);

  useEffect(() => { setHideError(false); }, [actionData]);

  const showError = actionData?.error && !hideError && !isSubmitting;

  return (
    <div className="d-flex h-75 align-items-center">
      <div className="mx-auto col-md-4 col-md-offset-3">
        <h2>Login</h2>
        <Form method="post">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input type="text" className="form-control" name="username" />
          </div>
          <div className="mt-2 form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              onChange={() => setHideError(true)}
            />
          </div>
          {showError && (
            <div className="help-block text-danger mt-2">{actionData.error}</div>
          )}
          <div className="form-group mt-2">
            <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Logging in..." : "Login"}
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default Login;
